var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "tg-card",
    _vm._b(
      {
        attrs: { dense: "", "no-padding": _vm.noPadding },
        scopedSlots: _vm._u(
          [
            _vm.showHeading
              ? {
                  key: "header",
                  fn: function() {
                    return [
                      _c("h3", {
                        domProps: { textContent: _vm._s(_vm.cardTitle) }
                      })
                    ]
                  },
                  proxy: true
                }
              : null
          ],
          null,
          true
        )
      },
      "tg-card",
      _vm.$attrs,
      false
    ),
    [
      _vm._v(" "),
      _vm.mode === "login"
        ? _c(
            "tg-login-form",
            _vm._b(
              {
                attrs: { "show-field-vertical": _vm.showFieldVertical },
                on: {
                  "go-to-forgot-password": function($event) {
                    _vm.mode = "forgot-password"
                  }
                }
              },
              "tg-login-form",
              _vm.loginSettings,
              false
            )
          )
        : _c(
            "tg-forgot-password-form",
            _vm._b(
              {
                on: {
                  "go-to-login": function($event) {
                    _vm.mode = "login"
                  },
                  "go-to-register": function($event) {
                    return _vm.$emit("register")
                  }
                }
              },
              "tg-forgot-password-form",
              _vm.forgotPasswordSettings,
              false
            )
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }